/**
 * ComingSoon — wraps a designed page so it stays visible as a teaser but is
 * completely non-interactable, with a bold COMING SOON banner over it.
 */
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function ComingSoon({ note, children }: { note?: string; children: React.ReactNode }) {
  const { t } = useTranslation('v2');
  return (
    <div className="relative min-h-screen">
      {/* The designed page — visible, but inert */}
      <div className="pointer-events-none select-none opacity-50 saturate-50" aria-hidden>
        {children}
      </div>

      {/* Banner */}
      <div className="absolute inset-0 z-10 flex items-center justify-center">
        <div className="text-center px-8 py-10 rounded-3xl bg-[#121218]/80 backdrop-blur-md border border-primary/30 shadow-glow animate-slide-up max-w-md mx-4">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/15 border border-primary/40 text-primary text-[11px] font-bold uppercase tracking-widest mb-4">
            <Sparkles className="w-3.5 h-3.5" /> {t('comingSoon.inTheWorks')}
          </span>
          <h2 className="text-4xl font-extrabold tracking-tight bg-gradient-to-r from-primary via-accent to-accent bg-clip-text text-transparent">
            {t('comingSoon.comingSoon')}
          </h2>
          {note && <p className="text-sm text-text-secondary mt-3 leading-relaxed">{note}</p>}
        </div>
      </div>
    </div>
  );
}
